import PropTypes from 'prop-types';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { HTMLTable } from '@blueprintjs/core';
import './KwicTable.css';

class Tokens extends React.PureComponent {

  state = {
     
  }

  render() {
    const { tokens, t } = this.props;

    const tokenRows = tokens.map(token => (
        <tr key={token.id}>
          <td>{token.id}</td>
          <td>{token.form}</td>
          <td>{token.lem}</td>
          <td>{token.cat}</td>
          <td>{token.fea}</td>
          {token.bgn && 
            <td>{token.bgn}</td>
          }
          {token.end && 
            <td>{token.end}</td>
          }
          {token.loc && 
            <td>{token.loc}</td>
          }
        </tr>
      ));

        return (
          <div className='dialogContainer'>
            <HTMLTable bordered={true}>
                <thead>
                    <tr>
                    <th>{t('id')}</th>
                    <th>{t('form')}</th>
                    <th>{t('lemma')}</th>
                    <th>{t('category')}</th>
                    <th>{t('features')}</th>
                    {tokens[0].bgn && 
                      <th>{t('beginning')}</th>
                    }
                    {tokens[0].end && 
                      <th>{t('ending')}</th>
                    }
                    {tokens[0].loc && 
                      <th>{t('loc')}</th>
                    }                    
                    </tr>
                </thead>
                <tbody>
                    {tokenRows}
                </tbody>
            </HTMLTable>
          </div>   
        );

  }
}

Tokens.propTypes = {
        tokens: PropTypes.array,
};

export default withTranslation()(Tokens);
